import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../constants/common'
import { NotificationInline } from '../../Notification'
import { QA_NAME_GRETA_AI_CHAT_LIMIT_NOTICE } from '../GretaAIChat.constants'
import { GretaAIChatMarkdownLink } from '../GretaAIChatMarkdownLink'

import * as styles from './GretaAIChatLimitNotice.module.css'

function GretaAIChatLimitNotice() {
  const { t } = useTranslation()

  return (
    <NotificationInline
      className={styles.notice}
      qaName={QA_NAME_GRETA_AI_CHAT_LIMIT_NOTICE}
      text={t('Greta.LimitNoticeKey')}
      type={NOTIFICATION_TYPE.info}
    >
      <p className={styles.contact}>
        {t('Greta.LimitNoticeContactKey')}{' '}
        <GretaAIChatMarkdownLink href='mailto:support@idwell.com'>
          {t('Greta.LimitNoticeSupportEmailKey')}
        </GretaAIChatMarkdownLink>
      </p>
    </NotificationInline>
  )
}

export default GretaAIChatLimitNotice
